'use strict';

// Español por default
const i18n = {
    previousMonth: 'Anterior',
    nextMonth: 'Siguiente',
    months: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    weekdays: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    weekdaysShort: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá']
};

angular.module('datePicker', [])

.directive('datePicker', function(){
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope,element,attrs,model){
			var input = element[0];
			//if(window.chrome){input.setAttribute('type', 'text');element.addClass('form__field--date');}
			var picker;
			picker = new Pikaday({
        field: input,
        i18n,
				format: 'DD/MM/YY',
                maxYear: new Date().getFullYear() + 6,
                onSelect: function (date) {
                    model.$setViewValue(moment(date).format('DD/MM/YY'));
					if(attrs.onDateSelect)
					{
						scope.$apply(attrs.onDateSelect+'("'+moment(date).format('DD/MM/YY')+'")');
					}
				}
			});

			input.addEventListener('touchstart', function(e){
				this.addEventListener('focus',function(e){
					$('.pika-single').addClass('hidden');
					e.preventDefault();
				});
			});
		}
	};
})

// Directiva para rangos de fecha (desde "fecha" hasta "fecha")
// Atributos:
//  - (REQUERIDO) date-picker-ranges: Se le pasa el id del input que va a recibir la segunda fecha (ej. '#toDate')
//  - (REQUERIDO) from-date: El nombre del objeto que va a almacenar el dato de la primera fecha
//  - (REQUERIDO) to-date: El nombre del objeto que va a almacenar el dato de la segunda fecha
//  - (OPCIONAL)  date-format: Un string con el formato que debe tener la fecha, si se utiliza
//                             esta opcion el dato de la fecha sera guardado como un string.

.directive('datePickerRanges', function(){
	return {
		scope: {
			fromDate: '=',
			toDate: '='
		},
		restrict: 'A',
		link: function($scope, element, attrs) {
			
			var firstDateInput = element[0];
			var secondDateInput = $(attrs.datePickerRanges)[0];
			if(window.chrome){
				firstDateInput.setAttribute('type', 'text');element.addClass('form__field--date');
				secondDateInput.setAttribute('type', 'text');$(attrs.datePickerRanges).addClass('form__field--date');
			}

			var picker1, picker2;
			var modelFormat = (attrs.dateFormat) ? attrs.dateFormat:null;

			picker1 = new Pikaday({
                field: firstDateInput,
                i18n,
				format: 'DD/MM/YY',
				maxDate: new Date(9000,1,1),
				onSelect: function(date){
					
					picker2.config({minDate:date});
					if(picker2._d < date)
					{
						var momentDate = moment(date.toString()).add('days',1);
						picker2.setMoment(momentDate);

						$scope.toDate = (!modelFormat) ? momentDate:momentDate.format(modelFormat);
					}

					$scope.fromDate = (!modelFormat) ? moment(date):moment(date).format(modelFormat);

					$scope.$apply();
				}
			});

			picker2 = new Pikaday({
                field: secondDateInput,
                i18n,
				format:'DD/MM/YY',
				maxDate: new Date(9000,1,1),
				onSelect: function(date){
					
					if(!picker1._d)
					{
						var momentDate = moment(date.toString()).subtract('days',1);
						picker1.setMoment(momentDate);

						$scope.fromDate = (!modelFormat) ? momentDate:momentDate.format(modelFormat);
					}

					$scope.toDate = (!modelFormat) ? moment(date):moment(date).format(modelFormat);

					$scope.$apply();
				}
			});

			//picker2.setMoment(moment().format('DD/MM/YY'));

			firstDateInput.addEventListener('touchstart', function(e){
				this.addEventListener('focus',function(e){
					$('.pika-single').addClass('hidden');
					e.preventDefault();
				});
			});

			secondDateInput.addEventListener('touchstart', function(e){
				this.addEventListener('focus',function(e){
					$('.pika-single').addClass('hidden');
					e.preventDefault();
				});
			});
		}
	};
})

.directive('datePickerRange', function(){
	return {
		restrict: 'A',
		scope:false,
		link: function(scope,element,attrs){
			
			var firstDateInput = element[0];
			var secondDateInput = $(attrs.datePickerRange)[0];
			//var defaultDate = attrs.datePicker;
			if(window.chrome){
				firstDateInput.setAttribute('type', 'text');element.addClass('date-input');
				secondDateInput.setAttribute('type', 'text');$(attrs.datePickerRange).addClass('date-input');
			}

			var picker1, picker2;

			picker1 = new Pikaday({
                field: firstDateInput,
                i18n,
				format: 'DD/MM/YY',
				maxDate: new Date(9000,1,1),
				onSelect: function(date){
					
					picker2.config({minDate:date});
					if(picker2._d < date)
					{
						var momentDate = moment(date.toString()).add('days',1);
						picker2.setMoment(momentDate);

						if(attrs.onToDateSelect)
						{
							scope.$apply(attrs.onToDateSelect+'("'+momentDate.format('DD/MM/YY')+'")');
						}
					}

					if(attrs.onFromDateSelect)
					{
						scope.$apply(attrs.onFromDateSelect+'("'+moment(date).format('DD/MM/YY')+'")');
					}
				}
			});

			picker2 = new Pikaday({
                field: secondDateInput,
                i18n,
				format:'DD/MM/YY',
				maxDate: new Date(9000,1,1),
				onSelect: function(date){
					
					if(!picker1._d)
					{
						var momentDate = moment(date.toString()).subtract('days',1);
						picker1.setMoment(momentDate);

						if(attrs.onFromDateSelect)
						{
							scope.$apply(attrs.onFromDateSelect+'("'+momentDate.format('DD/MM/YY')+'")');
						}
					}

					if(attrs.onToDateSelect)
					{
						scope.$apply(attrs.onToDateSelect+'("'+moment(date).format('DD/MM/YY')+'")');
					}
				}
			});

			//picker2.setMoment(moment().format('DD/MM/YY'));

			firstDateInput.addEventListener('touchstart', function(e){
				this.addEventListener('focus',function(e){
					$('.pika-single').addClass('hidden');
					e.preventDefault();
				});
			});

			secondDateInput.addEventListener('touchstart', function(e){
				this.addEventListener('focus',function(e){
					$('.pika-single').addClass('hidden');
					e.preventDefault();
				});
			});
		}
	};
});
